(() => {

  const capitalizeWords = (sentence) => {
    let words = sentence.split(' ');
    // maps through words, returns first letter capitalized followed by rest of string normal
    let capped = words.map((word) => word.slice(0, 1).toUpperCase() + word.slice(1));
    return capped.join(' ');
  }

  const filterSentence = (sentence) => {
    const alpha = 'abcdefghijklmnopqrstuvwxyz';
    const digits = '0123456789';
    const allowed = alpha + alpha.toUpperCase() + digits + ' ';
    const filtered = sentence
    .split('')
    .map((l) => l === '-' || l === '_' ? ' ' : l)
    .filter((l) => allowed.includes(l))
    .join('');

    return filtered;
  }

  const altFromSrc = (src) => {
    let chunks = src.split("/");
    let fname = chunks[chunks.length - 1];
    let slug = fname.split(".")[0];
    // Replace only removes 1 instance of substr, split join pattern gets all
    let filtered = filterSentence(slug);
    let alt = capitalizeWords(filtered);
    return alt;
  }


  const tagImages = () => {
    let canClear = false;

    setTimeout(() => {
      canClear = true;
    }, 10000);

    const inter = setInterval(() => {
      const imgs = document.querySelectorAll('img');
      let missingAlt = false;
      for (const img of imgs) {
        if (!img.alt) {
          const dataSrc = img.getAttribute('data-src') || img.getAttribute('src') || 'Img';
          img.alt = altFromSrc(dataSrc);
          missingAlt = true;
        }
      }

      if (!missingAlt && canClear) {
        clearInterval(inter);
      }
    }, 50);
  };

  tagImages();

})();
